import { render, staticRenderFns } from "./ResizeHorizontal.vue?vue&type=template&id=0af7626c&scoped=true"
import script from "./ResizeHorizontal.vue?vue&type=script&lang=js"
export * from "./ResizeHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af7626c",
  null
  
)

export default component.exports